import React, { useState, useEffect, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./HomeBanner.css";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Banners } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";


const HomeBanner = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    const res = await Banners();
    if (res?.success) {
      setBanner(res.data);
    }
  };
  useEffect(() => {
    getBanner();
  }, []);
  return (
    <>

      <section className="Home-Banner">
        <div className="container-fluid p-0">
          <Swiper
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            modules={[Autoplay, Pagination, Navigation]}
            autoplay={{
              delay: 2500,
            }}
            className="mySwiper"
          >
            {banner?.map((slide, index) => (
              <SwiperSlide key={index}>
                <img
                  className="Banner-image"
                  src={IMG_URL + slide?.image}
                  alt="Banner"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(
                      `/shop?category_id=${slide.category_id}&category_image=${slide.image}&sub_category_id=${slide.sub_category_id}`
                    )
                  }
                />
              </SwiperSlide>
            ))}

          </Swiper>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
